// import React, {useState, useEffect, useCallback} from 'react'
import React from 'react'
import {Modal, ModalTitle, ParagraphText as Text} from '@thryvlabs/maverick'

const McConfirmModal = () => {
  const handleContinue = () => {
    window.location.reload()
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <Modal
        btnText="Continue"
        btnType={'primary'}
        action
        footer
        btnActionText="Ok"
        btnAction={handleContinue}
        onClose={null}
        actionClose={true}
        openOnLoad
        altBtn={<></>}
      >
        <div className="text-center">
          <ModalTitle variant="subtitle" size="lg">
            Heads up!
          </ModalTitle>
          <Text variant="reg">
            Marketing Center was removed, so we gave your order a fresh start.
            Please re-select your products.
          </Text>
        </div>
      </Modal>
    </div>
  )
}

export {McConfirmModal}
